import script from "./TheLeftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLeftMenu.vue?vue&type=script&setup=true&lang=js"

import "./TheLeftMenu.vue?vue&type=style&index=0&id=527a5e6e&scoped=true&lang=css"

import exportComponent from "D:\\Работа\\vue3\\_hackatons\\latest_version\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-527a5e6e"]])

export default __exports__